module.exports = __webpack_public_path__ + "static/img/wav.94964108.png";